export default {
  elements: {
    flower: "flower",
  },
};
